/* template */
<template><page><div :class='["radio-page"]'><base-container><radio-example></radio-example><radio-disabled></radio-disabled><radio-ui-right></radio-ui-right></base-container></div></page></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"mid":"_7064a6ae"}'>
.radio-page
  height 100%
  background-color rgba(239, 239, 244, .7)
.cube-radio-demos
  padding 5px 10px
  box-sizing border-box
  background-color #fff
.desc
  margin-top 15px
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_7064a6ae"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_7064a6ae"}
  /** script content **/
  require("./index.mpx.js?isPage!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=page&index=0&isPage&lang=js&mpx&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_7064a6ae"],
    ctorType: "page",
    outputPath: "",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'base-container':getComponent(require("../../components/base-container/index.mpx?isComponent&outputPath=components%2Findexa53ae8d2%2Findex")),'radio-example':getComponent(require("./radio.mpx?isComponent&outputPath=components%2Fradio83ca495c%2Findex")),'radio-disabled':getComponent(require("./radio-disabled.mpx?isComponent&outputPath=components%2Fradio-disabled7c3342c5%2Findex")),'radio-ui-right':getComponent(require("./radio-ui-right.mpx?isComponent&outputPath=components%2Fradio-ui-right3fc27b28%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>